<!-- ExpertEventNotifications toggle -->
<button mat-icon-button (click)="openPanel()" #expertEventNotificationsOrigin>
  @if (vm.unreadCount$$() > 0) {
    <span
      class="z-999 absolute left-0 right-0 top-0 flex h-3 items-center justify-center">
      <span
        class="bg-primary-500 text-primary-50 ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full px-1 text-xs font-medium">
        {{ vm.unreadCount$$() }}
      </span>
    </span>
  }
  <mat-icon [svgIcon]="'heroicons_outline:inbox'" />
</button>

<!-- ExpertEventNotifications panel -->
<ng-template #expertEventNotificationsPanel>
  <div
    class="sm:min-w-90 sm:w-90 fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:rounded-2xl">
    <!-- Header -->
    <div
      class="bg-accent text-on-accent flex shrink-0 items-center py-4 pl-6 pr-4">
      <div class="-ml-1 mr-3 sm:hidden">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon
            class="icon-size-5 text-current"
            [svgIcon]="'heroicons_solid:x'" />
        </button>
      </div>
      <div class="text-lg font-medium leading-10">이벤트 알림</div>
      <div class="ml-auto">
        <button
          mat-icon-button
          [matTooltip]="'모두 읽음 표시'"
          [disabled]="vm.unreadCount$$() === 0"
          (click)="vm.readAllExpertEventNotifications()">
          <mat-icon
            class="icon-size-5 text-current"
            [svgIcon]="'heroicons_solid:envelope-open'" />
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="bg-card sm:max-h-120 relative flex flex-auto flex-col divide-y">
      <ng-scrollbar orientation="vertical">
        <div
          infiniteScroll
          [scrollWindow]="false"
          [infiniteScrollDistance]="4"
          (scrolled)="vm.fetchNextExpertEventNotificationSlice()">
          <div class="flex flex-row justify-end px-4 py-2">
            <mat-slide-toggle
              labelPosition="before"
              color="primary"
              [checked]="vm.showOnlyUnread$$()"
              (change)="
                vm.toggleShowOnlyUnreadExpertEventNotifications($event.checked)
              ">
              안 읽은 알림만 보기
            </mat-slide-toggle>
          </div>

          <!-- ExpertEventNotifications -->
          @for (item of vm.slice$$()?.content; track item.id) {
            <div
              class="group flex hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
              [ngClass]="{ unread: !item.readAt }">
              <!-- ExpertEventNotification without a link -->
              <div class="flex flex-auto py-5 pl-6">
                <ng-container
                  *ngTemplateOutlet="expertEventNotificationContent" />
              </div>
              <!-- Actions -->
              <div class="relative my-5 ml-2 mr-6 flex flex-col">
                <!-- Indicator -->
                <button
                  class="h-6 min-h-6 w-6"
                  mat-icon-button
                  (click)="vm.toggleExpertEventNotification(item)"
                  [matTooltip]="item.readAt ? '안 읽음 표시' : '읽음 표시'">
                  <span
                    class="h-2 w-2 rounded-full"
                    [ngClass]="{
                      'bg-gray-400 sm:opacity-0 sm:group-hover:opacity-100 dark:bg-gray-500':
                        item.readAt,
                      'bg-primary': !item.readAt,
                    }"></span>
                </button>
              </div>
            </div>
            <!-- ExpertEventNotification content template -->
            <ng-template #expertEventNotificationContent>
              @switch (item.type) {
                @case ('ExpertCreated') {
                  <app-expert-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberJoined') {
                  <app-expert-member-joined-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberPassExpiring') {
                  <app-expert-member-pass-expiring-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('FoodCardResolved') {
                  <app-food-card-resolved-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberFoodCardFeedbackAwaiting') {
                  <app-expert-member-food-card-feedback-awaiting-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberFoodCardFeedbackCommentCreated') {
                  <app-expert-member-food-card-feedback-comment-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberFoodCardFeedbackEmojiReactionCreated') {
                  <app-expert-member-food-card-feedback-emoji-reaction-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case (
                  'ExpertMemberFoodCardFeedbackCommentEmojiReactionCreated'
                ) {
                  <app-expert-member-food-card-feedback-comment-emoji-reaction-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberWorkoutFeedbackAwaiting') {
                  <app-expert-member-workout-feedback-awaiting-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberWorkoutFeedbackCommentCreated') {
                  <app-expert-member-workout-feedback-comment-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertMemberWorkoutFeedbackEmojiReactionCreated') {
                  <app-expert-member-workout-feedback-emoji-reaction-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case (
                  'ExpertMemberWorkoutFeedbackCommentEmojiReactionCreated'
                ) {
                  <app-expert-member-workout-feedback-comment-emoji-reaction-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionCreated') {
                  <app-expert-session-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionScheduleCreated') {
                  <app-expert-session-schedule-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionScheduleReminder') {
                  <app-expert-session-schedule-reminder-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionNotCompleted') {
                  <app-expert-session-not-completed-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionCommentCreated') {
                  <app-expert-session-comment-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionEmojiReactionCreated') {
                  <app-expert-session-emoji-reaction-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertSessionCommentEmojiReactionCreated') {
                  <app-expert-session-comment-emoji-reaction-created-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertWorkspaceExpertJoinInquiryOpened') {
                  <app-expert-workspace-expert-join-inquiry-opened-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('ExpertWorkspaceCreditPointExpiring') {
                  <app-expert-workspace-credit-point-expiring-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('MemberGeneralMissionCheckedByDate') {
                  <app-member-general-mission-checked-by-date-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('MemberWorkoutissionCheckedByDate') {
                  <app-member-workout-mission-checked-by-date-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('CreditPointCreatedToReferrerExpertWorkspace') {
                  <app-credit-point-created-to-referrer-expert-workspace-notification
                    [notification]="item"
                    class="w-full" />
                }
                @case ('CreditPointCreatedToRefereeExpertWorkspace') {
                  <app-credit-point-created-to-referee-expert-workspace-notification
                    [notification]="item"
                    class="w-full" />
                }
              }
            </ng-template>
          }
          <!-- No expertEventNotifications -->
          @if (!vm.slice$$()?.content || !vm.slice$$()?.content.length) {
            <app-empty-expert-event-notification class="p-16" />
          }
        </div>
      </ng-scrollbar>
    </div>
  </div>
</ng-template>
